export const generateAppConfig = () => {
  let exportResult = {
    appRepoLocation: "https://sg-app.redangholiday.com",
    backendUrl: "http://localhost:3100",
    agentBackendUrl: "http://localhost:4230",
    jsReportUrl: "http://localhost:5488",
  };
  if (process.env.REACT_APP_PRODUCTION_MODE === "TEST") {
    exportResult.appRepoLocation = "https://sg-app.redangholiday.com";
    exportResult.backendUrl = "https://sg-api.redangholiday.com/admin";
    exportResult.agentBackendUrl =
      "https://sg-api.redangholiday.com/business";
    exportResult.userPortalBackendUrl =
      "https://sg-api.redangholiday.com/app";
    exportResult.jsReportUrl = "https://sg-report.redangholiday.com";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "STAGE") {
    exportResult.appRepoLocation = "https://app.travoxis.com";
    exportResult.backendUrl = "https://admin-api.travoxis.com";
    exportResult.agentBackendUrl = "https://business-api.travoxis.com";
    exportResult.userPortalBackendUrl = "https://app-api.travoxis.com";
    exportResult.jsReportUrl = "https://report-test.summerbayresort.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "PROD") {
    exportResult.appRepoLocation = "https://app.redangholiday.com";
    exportResult.backendUrl = "https://api.redangholiday.com/admin";
    exportResult.agentBackendUrl =
      "https://api.redangholiday.com/business";
    exportResult.userPortalBackendUrl =
      "https://api.redangholiday.com/app";
    exportResult.jsReportUrl = "https://report.redangholiday.com";
  }
  return exportResult;
};
